import { Checkbox, Divider, Switch } from "antd";
import { CheckboxValueType } from "antd/lib/checkbox/Group";

import React, { useEffect, useState } from "react";
import Loadding from "../../../components/common/loadding";
import SendListItem from "../../../components/member/finddoc3/sendListItem";
import kpiList from "../../../constants/enum/kpi";
import curriculumService from "../../../services/curriculum.service";
import sendListService from "../../../services/sendList.service";

const FindDoc = () => {
  const [status, setStatus] = useState(true);
  const [load, setLoad] = useState(false);
  const [kpi, setKpi] = useState<any[]>([]);
  const [kpiSelect, setKpiSelect] = useState<CheckboxValueType[]>([]);
  const [swSend, setSwSend] = useState(false);
  const [curri, setCurri] = useState<any[]>([]);

  const [level, setLevel] = useState("");
  const [year, setYear] = useState("");
  const [courseCode, setCourseCode] = useState("");
  const [courseName, setCourseName] = useState("");
  const [term, setTerm] = useState("");
  const [curriSelect, setCurriSelect] = useState("");

  const [sendList, setSendList] = useState<any[]>([]);

  useEffect(() => {
    (async () => {
      if (level === "tqf") {
        setKpi(kpiList.kpiTQF);
      } else if (level === "mhesi") {
        setKpi(kpiList.kpiMhesi);
      } else {
        setKpi([]);
      }
      await curriculumService.getByType(level).then((res) => {
        setCurri(res.data);
      });
      setStatus(false);
    })();
  }, [level]);

  const onSubmit = async (event: any) => {
    event.preventDefault();
    setSendList([]);
    setLoad(true);

    await sendListService
      .getDoc3({
        type: level,
        year,
        term,
        courseCode,
        courseName,
        curriId: curriSelect,
      })
      .then((res) => {
        setSendList(res.data);
        setLoad(false);
      });
  };

  if (status) {
    return <Loadding />;
  }
  return (
    <>
      <div className="container">
        <h3 className="text-start mt-3">ค้นหาเอกสาร</h3>
        <div className="row mt-3">
          <form onSubmit={onSubmit}>
            <div className="col p-3 mb-4 bg-light rounded-4">
              <div className="row">
                <div className="col-2">
                  <select
                    className="form-select"
                    name="type"
                    onChange={(e) => setLevel(e.target.value)}
                    value={level}
                  >
                    <option value="">ประเภทเอกสาร</option>
                    <option value="tqf">มคอ.</option>
                    <option value="mhesi">อชว.</option>
                  </select>
                </div>
                <div className="col-2">
                  <input
                    name="year"
                    className="form-control"
                    placeholder="ปีการศึกษา"
                    onChange={(e) => setYear(e.target.value)}
                    required
                  />
                </div>
                <div className="col-2">
                  <select
                    className="form-select"
                    onChange={(e) => setTerm(e.target.value)}
                  >
                    <option value="">ภาคการศึกษา</option>
                    <option value="1">ภาคเรียนที่ 1</option>
                    <option value="2">ภาคเรียนที่ 2</option>
                    <option value="3">ภาคเรียนฤดูร้อน</option>
                  </select>
                </div>
                <div className="col-2">
                  <input
                    className="form-control"
                    placeholder="รหัสวิชา"
                    onChange={(e) => setCourseCode(e.target.value)}
                  />
                </div>
                <div className="col">
                  <input
                    className="form-control"
                    placeholder="ชื่อวิชา"
                    onChange={(e) => setCourseName(e.target.value)}
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col">
                  <select
                    className="form-select"
                    onChange={(e) => {
                      setCurriSelect(e.target.value);
                    }}
                  >
                    <option value="">เลือกหลักสูตร</option>
                    {curri.map((i) => {
                      return (
                        <option key={i.id} value={i.id}>
                          {i.name} ({i.shortName})
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-2 mt-2">
                  สถานะการส่ง{" "}
                  <Switch
                    checkedChildren={"ส่งแล้ว"}
                    unCheckedChildren={"ทั้งหมด"}
                    onChange={() => {
                      setSwSend(!swSend);
                      setKpiSelect([]);
                    }}
                  />
                </div>
              </div>
              {swSend && (
                <div className="row mt-2">
                  <div className="col text-start">
                    <Divider orientation="left">เลือก KPI ที่ต้องการ</Divider>
                    <div className="row">
                      <div className="col-1"></div>
                      <div className="col">
                        <Checkbox.Group
                          style={{ width: "100%" }}
                          onChange={(checkedValues: CheckboxValueType[]) => {
                            setKpiSelect(checkedValues);
                          }}
                        >
                          {kpi.map((item) => {
                            return (
                              <div key={item.id} className="row">
                                <Checkbox value={item.value}>
                                  [{item.value}] {item.name}
                                </Checkbox>
                              </div>
                            );
                          })}
                        </Checkbox.Group>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className="row mt-2">
                <div className="col"></div>
                <div className="col-2">
                  <button className="btn btn-success col-12" type="submit">
                    ค้นหา
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div>
          <table className="table table-hover table-responsive  table-striped">
            <thead className="table-dark">
              <tr>
                <th scope="col" style={{ width: "10%" }}>
                  รหัสวิชา
                </th>
                <th scope="col">ชื่อวิชา</th>
                <th scope="col">หน่วยกิต</th>
                <th scope="col">ตัวย่อหลักสูตร</th>
                <th scope="col">ปีการศึกษา</th>
                <th scope="col">ภาคการศึกษา</th>
                <th scope="col" style={{ width: "15%" }}>
                  อาจารย์ผู้รับผิดชอบ/กลุ่มเรียน
                </th>
                <th scope="col" style={{ width: "15%" }}>
                  รายการส่ง
                </th>
                {/* <th scope="col">KPI</th> */}
                <th scope="col" style={{ width: "8%" }}>
                  มคอ./อชว.3
                </th>
                <th scope="col" style={{ width: "8%" }}>
                  มคอ./อชว.5
                </th>
              </tr>
            </thead>
            <tbody>
              {!load && sendList.length === 0 && (
                <tr>
                  <td colSpan={10} className="text-danger">
                    <i className="bi bi-folder-x"></i> ไม่พบเอกสาร
                  </td>
                </tr>
              )}
              {!load &&
                sendList.map((doc3: any) => {
                  return (
                    <SendListItem
                      key={doc3.id}
                      doc3={doc3}
                      kpi={kpiSelect}
                      send={swSend}
                    />
                  );
                })}

              {load && (
                <tr>
                  <td colSpan={9}>
                    <Loadding />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default FindDoc;
